import ary from '@Ravnur-Inc/nanoutils/ary';
import { showErrorNotification } from '@Ravnur-Inc/notifications/service';

import { convertFromError } from '@/transformers/notifications';

export function $processException(e: Dictionary<unknown> | unknown) {
  convertFromError(e).forEach(ary(1, showErrorNotification));
}
